import React from "react";
import RowCheckbox from "./cells/rowCheckbox";
import RowMove from "./cells/rowMove";
import MultiDnD from "./multidnd";
import RowRadioButton from "./cells/rowRadioButton";
import { withStyles } from "material-ui/styles";

import styles from "./styles";
import ReactTable from "react-table";
import "react-table/react-table.css";
import ReactTablePagination from "./custom/pagination";
import next from "../common/results/views/next";

class Table extends React.Component {
  constructor(props) {
    super(props);
    (this.state = {
      ...props,
      allowSelect: false,
      selectAllTest: false,
      tempselected: {},
      previousRow: null
    }),
      (this.inputtimer = null);
  }

  componentWillMount() {
    const { aggregateCols, classes, expandedKeys } = this.props;
    let state = { ...this.state };
    this.setColumns({ ...this.props });

    if (aggregateCols) {
      state = {
        ...state,
        minRows: 1
      };

      this.setState({ ...state });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setColumns({ ...nextProps });
    //multiCheck here
    if (
      nextProps.selectAll != undefined &&
      this.state.selectAllTest != nextProps.selectAll
    ) {
      this.setState({ selectAllTest: nextProps.selectAll });
    }
  }

  setColumns = props => {
    //console.log(props, "setColumns");
    let self = this.props;
    const currentThis = this;
    const {
      allowSelect,
      allowSelectOne,
      allowDnd,
      columns,
      toggleSelectAll,
      toggleRow,
      selected,
      selectAll,
      selectedTests
    } = props;
    const { tempselected, selectAllTest } = this.state;
    //console.log(tempselected, allowDnd, "table - setColumns");
    const __selected = { ...tempselected };
    if (allowDnd && !columns.find(x => x.id === "move")){
      columns.unshift({
        id: "move",
        filterable: false,
        minWidth: 65,
        display:true,
        Header: x => {
          return (<MultiDnD testCollection={selected} tests={selectedTests}></MultiDnD>)
        },
        sortable: false,
        Cell: cellData => {
          return (<React.Fragment><RowMove {...cellData}></RowMove></React.Fragment>)
        }
      });     
    }

    if (allowSelect && !columns.find(x => x.id === "select")) {
      columns.unshift({
        id: "select",
        filterable: false,
        maxWidth: 50,
        display: false,
        Header: x => {
          const { data, selected } = currentThis.props;
          const testsListId =
            data && data.length
              ? !this.props.isReportPage
                ? data.filter(o => o.hasOwnProperty("id")).map(o => o.id)
                : data
                    .filter(
                      o =>
                        o.hasOwnProperty("id") &&
                        (o.status.toLowerCase() === "completed" ||
                          o.status.toLowerCase() === "failed")
                    )
                    .map(o => o.id)
              : [];

          const selectedTestsId =
            selected && Object.keys(selected).length
              ? !this.props.isReportPage
                ? Object.keys(selected)
                    .filter(v => selected[v])
                    .map(v => parseInt(v))
                : Object.keys(selected)
                    .filter(v => selected[v])
                    .map(v => v)
              : []; 
          const isAllTestSelected = testsListId.every(v =>
            selectedTestsId.includes(v)
          );
          const all = selectAll
            ? data && data.length && selectAll && isAllTestSelected
            : data && data.length && isAllTestSelected;
          return (
            <React.Fragment>
              <RowCheckbox
                changeHandler={e => this.toggleSelectAll(e)}
                value={null}
                state={all}
              />
            </React.Fragment>
          );
        },
        sortable: false,
        accessor: d => d.id,
        Cell: o => {
          const { selected } = currentThis.props;
          return (
            <React.Fragment key={o.row.id}>
              <RowCheckbox
                changeHandler={e => this.toggleRow(e, self)}
                value={o.row.id}
                state={selected && selected[o.row.id] === true}
                disabled={
                  this.props.isReportPage &&
                  o.row.status.toLowerCase() !== "completed" &&
                  o.row.status.toLowerCase() !== "failed"
                }
              />
            </React.Fragment>
          );
        }
      });
    } else if (allowSelectOne && !columns.find(x => x.id === "select")) {
      columns.unshift({
        id: "select",
        filterable: false,
        maxWidth: 50,
        display: false,
        sortable: false,
        style: { borderColor: "red" },
        accessor: d => d.id,
        filterable: false,
        Cell: o => {
          const { selected } = currentThis.props;
          return (
            <React.Fragment key={o.row.id}>
              <RowRadioButton
                changeHandler={e => this.toggleRow(e, self)}
                value={o.row.id}
                state={selected && selected[o.row.id] === true}
              />
            </React.Fragment>
          );
        }
      });
    }
    const column = columns.find(x => x.id === "select");
    if (column) {
      column.filterable = false;
    }
    const _selected = { ...this.state }.tempselected;
    let selectedKeys = Object.keys(this.state.tempselected);
    let data = [...props.data];

    selectedKeys.map(key => {
      let row = data.find(x => {
        let temp = x.id;
        if (typeof temp === "number") {
          temp = temp.toString();
        }
        return temp === key;
      });
      if (!row) {
        delete _selected[key];
      }
    });

    this.setState({
      allowSelect: !!allowSelect,
      allowSelectOne: !!allowSelectOne,
      columns,
      tempselected: _selected,
      ...props
    });
  };
  toggleRow = (e, v) => {
    let a = this.props.testSelected;
    // e.preventDefault()
    const {
      selectedRows,
      allowSelect,
      allowSelectOne,
      selected,
      selectedTests,
      saveSelectedRow,
      previousRow
    } = this.props;
    let { tempselected } = this.state;
    const { data } = this.props;
    if (allowSelectOne && selected[e.target.value]) {
      selected[e.target.value] = false;
      tempselected[e.target.value] = false;
    } else {
      selected[e.target.value] = e.target.checked;
      tempselected[e.target.value] = e.target.checked;
    }
    if (allowSelectOne) {
      Object.keys(selected).map(sel => {
        if (isNaN(parseInt(sel, 10))) {
          if (sel !== e.target.value) {
            selected[sel] = false;
            tempselected[sel] = false;
          }
        } else {
          if (sel !== e.target.value) {
            selected[sel] = false;
            tempselected[sel] = false;
          }
        }
      });
    }

    if (!selected[e.target.value] && saveSelectedRow) {
      saveSelectedRow(null);
    }

    this.setState(
      {
        tempselected
      },
      () => {
        if (selectedRows) selectedRows(selected, selectedTests);
        if (
          !Object.keys(selected).filter(key => selected[key] === true).length &&
          saveSelectedRow
        ) {
          saveSelectedRow(null);
        }
      }
    );
  };

  toggleSelectAll = (e, v) => {
    // e.preventDefault()
    const {
      selectedRows,
      allowSelect,
      allowSelectOne,
      data,
      selectedTests,
      selected,
      saveSelectedRow
    } = this.props;
    let { tempselected } = this.state;
    data.forEach(d => {
      if (
        !(
          this.props.isReportPage &&
          d.status.toLowerCase() !== "completed" &&
          d.status.toLowerCase() !== "failed"
        )
      ) {
        if (!d.group) selected[d.id] = e.target.checked;
        tempselected[d.id] = e.target.checked;
      }
    });
    this.setState({
      selectAllTest: e.target.checked,
      tempselected
    });
    if (selectedRows) selectedRows(selected, selectedTests);
    saveSelectedRow(null);
  };

  render() {
    const {
      classes,
      translate,
      savePreferences,
      preferencesSaved,
      pager,
      columns,
      noDataText,
      isSGResultView,
      isNetScan,
      selectedRows,
      selected,
      saveSelectedRow,
      isUptime,
      jumpToPage,
      isUptimeView,
      changeBarClick
    } = this.props;

    let props = { ...this.props };
   
    return (
      <ReactTable
        onFetchData={e => {
          if (this.state.fetch && isUptime != true) {
            window.clearTimeout(this.inputtimer);
            this.inputtimer = setTimeout(() => {
              this.state.fetch(e, this.state.pager);
            }, 500);
          }
        }}
        {...this.state}
        className={classes.table}
        PaginationComponent={ReactTablePagination}
        pageText={translate ? translate("general_table_page") : "Page"}
        rowsText={translate ? translate("general_table_rows") : "Rows"}
        ofText={translate ? translate("general_table_of") : "of"}
        previousText={
          translate ? translate("general_table_previous") : "Previous"
        }
        nextText={translate ? translate("general_table_next") : "Next"}
        noDataText={
          translate && noDataText ? translate(noDataText) : "No Data Found"
        }
        pageSizeOptions={
          isSGResultView ? [10, 20, 50, 100] : [5, 10, 20, 25, 50, 100]
        }
        isUptime={isUptime}
        isUptimeView={isUptimeView}
        changeBarClick={changeBarClick}
        jumpToPage={jumpToPage}
        originalKey="_original"
        indexKey="_index"
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              // console.log('A Td Element was clicked!')
              // console.log('it produced this event:', e)
              // console.log('It was in this column:', column)
              // console.log('It was in this row:', rowInfo)
              // console.log('It was in this table instance:', instance)

              // IMPORTANT! React-Table uses onClick internally to trigger
              // events like expanding SubComponents and pivots.
              // By default a custom 'onClick' handler will override this functionality.
              // If you want to fire the original onClick handler, call the
              // 'handleOriginal' function.
              // let selectedRows = [];
              // if shift key is being pressed upon click and there is a row that was previously selected, grab all rows inbetween including both previous and current clicked rows
              const {
                previousRow,
                saveSelectedRow,
                isShiftSelectPage
              } = this.props;
              if (e.shiftKey && previousRow) {
                // if previous row is above current row in table
                if (previousRow.index < rowInfo.index) {
                  for (let i = previousRow.index; i < rowInfo.index; i++) {
                    if (state.sortedData[i].name) {
                      const {
                        selectedRows,
                        selected,
                        selectedTests
                      } = this.props;
                      let { tempselected } = this.state;
                      selected[state.sortedData[i].id] = true;
                      tempselected[state.sortedData[i].id] = true;
                      this.setState(
                        {
                          tempselected
                        },
                        () => {
                          if (selectedRows)
                            selectedRows(selected, selectedTests);
                        }
                      );
                    }
                  }
                } else {
                  for (let i = rowInfo.index; i <= previousRow.index; i++) {
                    if (state.sortedData[i].name) {
                      const {
                        selectedRows,
                        selected,
                        selectedTests
                      } = this.props;
                      let { tempselected } = this.state;
                      selected[state.sortedData[i].id] = true;
                      tempselected[state.sortedData[i].id] = true;
                      this.setState(
                        {
                          tempselected
                        },
                        () => {
                          if (selectedRows)
                            selectedRows(selected, selectedTests);
                        }
                      );
                    }
                  }
                }
              } else if (isShiftSelectPage) {
                saveSelectedRow(rowInfo);
              }
              if (e.shiftKey && isShiftSelectPage) {
                saveSelectedRow(rowInfo);
              }
              if (handleOriginal) {
                handleOriginal();
              }
            }
          };
        }}
        // Called when the page index is changed by the user
        onPageChange={pageIndex => {
          //if (isUptimeView) changeBarClick(false);
          const { isReportPage } = this.props;
          if (isReportPage && saveSelectedRow) {
            saveSelectedRow(null);
          }
          if (preferencesSaved && savePreferences) {
            pager.pageIndex = pageIndex;
            savePreferences(pager, columns, !preferencesSaved);
            saveSelectedRow(null);
          }
          // if (this.state.onPageChange) {
          //   pager.pageno = pageIndex + 1
          //   this.state.onPageChange(pager)
          // }
        }}
        // Called when the pageSize is changed by the user.
        onPageSizeChange={(pagesize, pageIndex) => {
          //const { selectedRows, allowSelectOne } = this.props
          // if (allowSelectOne) {
          //   let temp = {}
          //   this.setState({ tempselected: temp } , () => selectedRows({})
          //   )
          // }
          if (isUptimeView) changeBarClick(false);
          if (preferencesSaved && savePreferences) {
            pager.pagesize = pagesize;
            pager.pageIndex = 0;
            savePreferences(pager, columns, !preferencesSaved);
          }
        }}
        // Called when a sortable column header is clicked
        onSortedChange={(newSorted, column, shiftKey) => {
          if (preferencesSaved && savePreferences) {
            pager.sort = newSorted;
            savePreferences(pager, columns, !preferencesSaved);
          }
        }}
        // Called when a user enters a value into a filter input field
        onFilteredChange={(column, value) => {
          if (preferencesSaved && savePreferences) {
            pager.filter = column;
            pager.pageIndex = 0;
            savePreferences(pager, columns, !preferencesSaved);
          }
        }}
      >
        {(state, makeTable, instance) => {
          return (
            // <div style={{
            //   background: '#ffcf00',
            //   borderRadius: '5px',
            //   overflow: 'hidden',
            //   padding: '5px'
            // }}>
            //   <pre><code>state.allVisibleColumns === {JSON.stringify(state.allVisibleColumns, null, 4)}</code></pre>
            //   {makeTable()}
            // </div>

            <div>{makeTable()}</div>
          );
        }}
      </ReactTable>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { savePreferences, pager, columns, preferencesSaved } = this.props;
    if (savePreferences && !preferencesSaved) {
      savePreferences(pager, columns, !preferencesSaved);
    }
  }
}

export default withStyles(styles)(Table);



// WEBPACK FOOTER //
// ./src/components/table/index.js